import React from 'react'

const TripsTalks = () => (
  <article>
    <h2>Talks</h2>
    <p>Upcoming public speaking engagements include:</p>
    <ul>
      <li>Birdfair, Rutland Water - 0930 on 18 August 2019</li>
      <li>
        <a
          href="http://www.delmarworld.com/events/"
          target="_blank"
          rel="noreferrer"
        >
          The Perfect Cruise Show with Delmar Travel on 29 September 2019
        </a>
      </li>
      <li>Virgin Money Group - 3 October 2019 - private corporate event</li>
      <li>Royal Geographical Society, Hong Kong - October 2019</li>
      <li>Mold Camera Club, North Wales - 16 March 2020</li>
    </ul>
  </article>
)

export default TripsTalks
